"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lastra-a-signa": {
    "5bae8687": [{
      "hkey": "b40bcaa7",
      "slug": "ginestra-fiorentina-carcheri",
      "name": "Ginestra Fiorentina-Carcheri",
      "primary": true,
      "skipSearch": false
    }],
    "carcheri": [{
      "hkey": "b40bcaa7",
      "slug": "ginestra-fiorentina-carcheri",
      "name": "Ginestra Fiorentina-Carcheri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "108867f4": [{
      "hkey": "b40bcaa7",
      "slug": "ginestra-fiorentina-carcheri",
      "name": "Ginestra Fiorentina-Carcheri",
      "primary": true,
      "skipSearch": false
    }],
    "ginestra-fiorentina": [{
      "hkey": "b40bcaa7",
      "slug": "ginestra-fiorentina-carcheri",
      "name": "Ginestra Fiorentina-Carcheri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f006088e": [{
      "hkey": "efd5cb49",
      "slug": "lastra-a-signa",
      "name": "Lastra a Signa",
      "primary": true,
      "skipSearch": false
    }],
    "san-romolo": [{
      "hkey": "efd5cb49",
      "slug": "lastra-a-signa",
      "name": "Lastra a Signa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8c5e11d3": [{
      "hkey": "efd5cb49",
      "slug": "lastra-a-signa",
      "name": "Lastra a Signa",
      "primary": true,
      "skipSearch": false
    }],
    "vigliano": [{
      "hkey": "efd5cb49",
      "slug": "lastra-a-signa",
      "name": "Lastra a Signa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;